/* Mobile product gallery: one clear "n / N" counter instead of a long row of dots. */
(()=>{'use strict';
function setup(root=document){
  root.querySelectorAll('media-gallery slideshow-controls.media-gallery__mobile-controls').forEach(ctrl=>{
    if(ctrl.dataset.hvCount)return;
    const dots=[...ctrl.querySelectorAll('button[ref="dots[]"], .slideshow-controls__dots button')];
    if(dots.length<2)return;
    ctrl.dataset.hvCount='1';
    const pill=document.createElement('div');pill.className='hv-gal-count';pill.setAttribute('aria-hidden','true');ctrl.appendChild(pill);
    const update=()=>{let i=dots.findIndex(d=>d.getAttribute('aria-selected')==='true');if(i<0)i=0;pill.textContent=(i+1)+' / '+dots.length;};
    new MutationObserver(update).observe(ctrl,{attributes:true,attributeFilter:['aria-selected'],subtree:true});
    update();
  });
}
function init(){setup();document.addEventListener('shopify:section:load',()=>setup());const m=document.getElementById('MainContent');if(m)new MutationObserver(()=>setup()).observe(m,{childList:true,subtree:true});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();


/* Desktop: click-and-drag scrolling for sliders (mouse only; touch already swipes natively). */
(()=>{'use strict';
const SEL='.related-infinite-track,.hv-rec-chips,.product-card .swatches ul.swatch-view,.hv-collection-links';
let el=null,startX=0,startL=0,moved=false,suppress=false;
document.addEventListener('pointerdown',e=>{
  if(e.pointerType!=='mouse'||e.button!==0)return;
  const t=e.target.closest&&e.target.closest(SEL); if(!t)return;
  if(e.target.closest('select,input,textarea,.hv-card__opts'))return;
  el=t;startX=e.clientX;startL=t.scrollLeft;moved=false;
});
document.addEventListener('pointermove',e=>{
  if(!el)return; const dx=e.clientX-startX;
  if(!moved&&Math.abs(dx)>5){moved=true;el.classList.add('is-dragging');el.style.scrollBehavior='auto';el.style.scrollSnapType='none';}
  if(moved){el.scrollLeft=startL-dx;e.preventDefault();}
},{passive:false});
function end(){
  if(!el)return;
  if(moved){const t=el;suppress=true;setTimeout(()=>{suppress=false;t.classList.remove('is-dragging');t.style.scrollBehavior='';t.style.scrollSnapType='';},0);}
  el=null;
}
document.addEventListener('pointerup',end);document.addEventListener('pointercancel',end);
document.addEventListener('click',e=>{if(suppress){e.preventDefault();e.stopPropagation();}},true);
document.addEventListener('dragstart',e=>{if(e.target.closest&&e.target.closest(SEL))e.preventDefault();});
})();


/* Collection grid cards: Bestseller label + clean "n / N" image counter on top of the native cards. */
(()=>{'use strict';
let tagMap=null,loading=null;
const collHandle=()=>{const m=location.pathname.match(/\/collections\/([^\/?#]+)/);return m?m[1]:null;};
function load(){
  if(tagMap)return Promise.resolve(tagMap); if(loading)return loading;
  const h=collHandle(); if(!h){tagMap={};return Promise.resolve(tagMap);}
  loading=fetch('/collections/'+h+'/products.json?limit=250').then(r=>r.ok?r.json():{products:[]}).then(d=>{tagMap={};(d.products||[]).forEach(p=>{tagMap[p.handle]=p.tags||[];});return tagMap;}).catch(()=>{tagMap={};return tagMap;});
  return loading;
}
function enhance(){
  document.querySelectorAll('.product-grid product-card, results-list product-card').forEach(card=>{
    if(card.dataset.hvEnh)return; card.dataset.hvEnh='1';
    const g=card.querySelector('.card-gallery'); if(!g)return;
    const ss=g.querySelector('slideshow-slides');
    if(ss&&ss.children.length>1){
      const pill=document.createElement('div');pill.className='hv-cg-count';pill.setAttribute('aria-hidden','true');g.appendChild(pill);
      const upd=()=>{const k=Math.round(ss.scrollLeft/(ss.clientWidth||1));pill.textContent=(Math.min(k,ss.children.length-1)+1)+' / '+ss.children.length;};
      ss.addEventListener('scroll',upd,{passive:true});upd();
    }
    const qa=card.querySelector('quick-add-component'),pr=card.querySelector('product-price');
    if(qa&&pr&&!qa.classList.contains('hv-qa-moved')){const host=pr.closest('.product-card__content,.card-gallery~*')||pr.parentElement;const sw=card.querySelector('.swatches');(sw&&sw.parentNode?sw:pr).after(qa);qa.classList.add('hv-qa-moved');}
    const a=card.querySelector('a[href*="/products/"]'); if(!a)return;
    const handle=(a.getAttribute('href').split('/products/')[1]||'').split(/[?#]/)[0];
    load().then(m=>{if(handle&&m[handle]&&m[handle].includes('BESTSELLER')&&!g.querySelector('.hv-card__badge')){const b=document.createElement('span');b.className='hv-card__badge';b.textContent='Bestseller';g.appendChild(b);}});
  });
}
function init(){enhance();const m=document.getElementById('MainContent');if(m)new MutationObserver(()=>enhance()).observe(m,{childList:true,subtree:true});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

/* star rating -> smooth scroll to the reviews widget */
(function(){
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.product-details .jdgm-preview-badge');
    if(!b)return;
    var t=document.querySelector('.jdgm-review-widget,#judgeme_product_reviews,.jdgm-rev-widg');
    if(!t)return;
    e.preventDefault();e.stopPropagation();
    var sc=document.querySelector('.page-wrapper');
    var y=t.getBoundingClientRect().top-90;
    try{ if(sc&&sc.scrollHeight>sc.clientHeight+5&&getComputedStyle(sc).overflowY!=='visible'){sc.scrollBy({top:y,behavior:'smooth'});} else {window.scrollBy({top:y,behavior:'smooth'});} }catch(_){t.scrollIntoView();}
  },true);
})();

/* put the star rating on the same line as the BESTSELLER tag (rating on the right) */
(function(){
  function place(){
    var pd=document.querySelector('.product-details'); if(!pd)return;
    var pb=pd.querySelector('.jdgm-preview-badge'); if(!pb||pb.dataset.hvRow)return;
    var bs=pd.querySelector('.hv-badge');
    var row=document.createElement('div'); row.className='hv-toprow';
    var anchor=bs||pb.closest('.shopify-block,[class*=block]')||pb;
    var host=anchor.closest('.shopify-block')||anchor;
    host.parentNode.insertBefore(row,host);
    if(bs)row.appendChild(bs); else row.classList.add('hv-toprow--solo');
    row.appendChild(pb); pb.dataset.hvRow='1';
    var ph=pb.parentNode===row?null:null;
  }
  function run(){place();var m=document.querySelector('.product-details');if(m)new MutationObserver(place).observe(m,{childList:true,subtree:true});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
})();
